// Reports two page-speed numbers with the browser's own PerformanceObserver (no extra package):
// LCP, when the largest element was painted, and CLS, how much the layout shifted.
export default function reportWebVitals(onReport) {
  if (typeof onReport !== 'function' || typeof PerformanceObserver === 'undefined') return;
  const watch = (type, read) => {
    try { new PerformanceObserver((list) => list.getEntries().forEach((e) => onReport({ name: type, value: read(e) }))).observe({ type, buffered: true }); } catch { /* not supported */ }
  };
  watch('largest-contentful-paint', (e) => Math.round(e.startTime));
  watch('layout-shift', (e) => (e.hadRecentInput ? 0 : e.value));
}
